import * as VueRouter from 'vue-router'
import SiteEditor from './views/SiteEditor'
import SitesList from './views/SitesList'
import Login from './views/Login'
import Register from './views/Register'
import Permission from './views/Permission'
import ResetPassword from './views/ResetPassword'
import UserManagementView from './views/UserManagementView'
import Settings from './views/Settings'
import UserConfirmationOTP from './views/UserConfirmationOTP'
import ForgotPassword from "./views/ForgotPassword";
import ConfirmForgotPassword from "./views/ConfirmForgotPassword";
import GlobalComponents from "./views/GlobalComponents";
import ComponentEdit from './views/ComponentEdit.vue'

const routes = [
  { name: 'Login', path: '/login', component: Login },
  { name: 'Register', path: '/register', component: Register },
  { name: 'UserConfirmationOTP', path: '/email-verification', component: UserConfirmationOTP },
    {
    name: "ForgotPassword",
    path: "/forgot-password",
    component: ForgotPassword,
  },
  {
    name: "ConfirmForgotPassword",
    path: "/confirm-forgot-password",
    component: ConfirmForgotPassword,
  },
  { name: 'ResetPassword', path: '/reset-password', component: ResetPassword },
  { name: 'SitesList', path: '/site-list', component: SitesList },
  { name: 'GlobalComponents', path: '/component-list', component: GlobalComponents },
  { name: 'UserManagementView', path: '/users', component: UserManagementView },
  { name: 'SiteEditor', path: '/site-edit/:uri', component: SiteEditor },
  { name: 'ComponentEdit', path: '/comp-edit/:id', component: ComponentEdit },
  { name: 'ComponentsEditor', path: '/global-components', component: SiteEditor, props: { isComponentView: true } },
  { name: 'Permission', path: '/site-permission', component: Permission },
  { name: 'Settings', path: '/settings', component: Settings },
  { path: '/', redirect: '/site-list' }
]

const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(),
  routes
})

export default router
